import React from "react";

const EligibilitySuccess = ({
  isEligibilitySuccessModalOpen,
  closeEligibilitySuccess,
  loanProductName,
  loanLimit,
  handleContinueCreateLoan,
}) => {
  if (!isEligibilitySuccessModalOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-10">
      <div className="bg-white rounded-sm shadow-xl w-[670px] h-[340px] flex flex-col items-center justify-center p-8 text-center">
        <div className="mb-6 flex items-center justify-center w-[76px] h-[76px] rounded-full bg-blue-100">
          <div className="bg-blue-100 p-3 rounded-full">
            <img
              src="/blue-tick.png"
              alt="Awaiting Approval"
              className="w-12 h-12"
            />
          </div>
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          Member Eligible
        </h2>

        <p className="text-gray-600 text-sm mb-8 max-w-[420px] leading-relaxed">
          This member meets all the requirements and is eligible to apply for a
          <span className="font-semibold">
            {" "}
            {loanProductName || "[loan_productname]"}
          </span>{" "}
          of up to KES
          <span className="font-semibold">
            {" "}
            {loanLimit
              ? new Intl.NumberFormat("en-KE").format(loanLimit)
              : "0"}
          </span>
        </p>

        <div className="flex justify-center items-center space-x-4 mt-6">
          <button
            className="border border-[#074073] text-[14px] text-[#074073] w-[211px] h-[49px] rounded-md font-medium whitespace-nowrap hover:bg-[#074073] hover:text-white transition-colors duration-200"
            onClick={closeEligibilitySuccess}
          >
            Close
          </button>

          <button
            className="bg-[#074073] text-[14px] text-white w-[211px] h-[49px] rounded-md font-medium whitespace-nowrap hover:bg-[#06355d] transition-colors duration-200"
            onClick={handleContinueCreateLoan}
          >
            Continue to Create Loan
          </button>
        </div>
      </div>
    </div>
  );
};

export default EligibilitySuccess;
